const callStateList: { [x: number]: string } = {
  [-2]: 'Annulée',
  [-1]: 'Annulée',
  4: 'Terminée',
  5: 'Expirée',
};

export {
  callStateList,
}